<template>
  <section class="section">
    <h3>E-mails</h3>

    <p v-if="!emailCollection.items.length" class="flow-text center">
      Nenhum e-mail foi cadastrada.
    </p>
    <BaseCollection v-else>
      <template v-slot:items>
        <li
          v-for="(item, index) in emailCollection.items"
          v-bind:key="index"
          class="collection-item"
        >
          <BaseEmail v-bind="item" />
        </li>
      </template>
    </BaseCollection>
  </section>
</template>

<script>
import BaseEmail from "./BaseEmail.vue";

export default {
  name: "DadosContatoEmails",
  components: {
    BaseEmail
  },
  inheritAttrs: false,
  props: {
    readonly: Boolean,

    pessoaFisica: {
      type: Object,
      required: true,
      validator: value => value.id !== null && value.id !== undefined
    },
    emails: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      disabled: false,
      tiposEmail: [],
      progressBar: {
        useContainer: false
      },
      emailCollection: {
        items: this.emails.map(item => {
          const value = { ...item };

          return {
            ...this.buildElementProps(item.id),
            value
          };
        })
      }
    };
  },
  methods: {
    buildElementId(itemId, name) {
      return itemId
        ? `dadoscontato-email-${itemId}-${name}`
        : this.$utils.Object.uuid();
    },
    buildElementProps(itemId) {
      return {
        email: {
          id: this.buildElementId(itemId, "email"),
          label: "E-mail",
          gridExpression: "col s12 m7"
        },
        tipo: {
          id: this.buildElementId(itemId, "tipo"),
          label: "Tipo",
          gridExpression: "col s12 m5"
        }
      };
    }
  }
};
</script>
